import { CustomMenuItem, CustomSelect } from "../StyledComponents/StyledFields";
import { FormControl, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { isBoolean } from "lodash";

const styles = {
  textField: {
    border: "1px solid rgba(136, 46, 20, 0.4)",
    backgroundColor: "#FFF9E4",
    borderRadius: "8px",
  },
  errorTextField: {
    border: "1px solid #f05802",
    borderRadius: "8px",
    width: "100%",
    backgroundColor: "#FFF9E4",
  },
};

interface Option {
  label: string | number;
  value: string | number;
}

interface CustomSelectFieldProps {
  handleDropdownChange: (field: string, value: any) => void;
  errorMessage: string | undefined;
  dropDownList: any[];
  value: string | number | null;
  fieldName: string;
  id?: string;
  placeholder: string;
  optionLabel: string | number;
  optionValue: string | number;
  readOnly?: boolean;
  isLabelValue?: boolean;
}

const CustomSelectField = (props: CustomSelectFieldProps) => {
  const {
    handleDropdownChange,
    errorMessage,
    dropDownList,
    value,
    fieldName,
    id,
    placeholder,
    optionLabel,
    optionValue,
    readOnly,
    isLabelValue,
  } = props;

  return (
    <FormControl sx={{ width: "100%" }}>
      <CustomSelect
        IconComponent={KeyboardArrowDownIcon}
        id={id}
        value={value || placeholder}
        onChange={(e) => {
          handleDropdownChange(fieldName, e.target.value);
        }}
        readOnly={readOnly}
        disabled={readOnly}
        MenuProps={{
          PaperProps: {
            sx: {
              border: "1px solid #F05802",
              "& ul": {
                paddingTop: 0,
                paddingBottom: 0,
                overflowY: "auto",
                minHeight: "auto",
                maxHeight: "300px",
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#F3C539",
                  borderRadius: "6px",
                },
              },
            },
          },
        }}
        sx={[
          errorMessage ? styles.errorTextField : styles.textField,
          {
            "& .MuiSelect-outlined": {
              opacity: value ? 1 : 0.5,
            },
          },
        ]}
      >
        <CustomMenuItem value={placeholder} disabled sx={{ display: "none" }}>
          {placeholder}
        </CustomMenuItem>
        {dropDownList?.map((item: any, index: number) => (
          <CustomMenuItem key={index} value={item?.[optionValue]}>
            {isLabelValue
              ? `${item?.[optionValue]}-${item?.[optionLabel]}`
              : item?.[optionLabel]}
          </CustomMenuItem>
        ))}
      </CustomSelect>
      {errorMessage ? (
        <Typography sx={{ color: "red", fontSize: "12px" }}>
          {errorMessage}
        </Typography>
      ) : (
        ""
      )}
    </FormControl>
  );
};

export default CustomSelectField;